import React from 'react';
import { Box, Button } from '@mui/material';
import { GoogleMap, Marker } from '@react-google-maps/api';

import MobileSpacesList from './mobileSpacesList';

const MAP_CONFIG = {
    containerStyle: {
        width: '100%',
        height: ({ isXS }) => isXS ? 'calc(100vh - 72px - 170px)' : 'calc(100vh - 72px)',
    },
    defaultCenter: {
        lat: 51.52268795372802,
        lng: -0.08518920377573923,
    },
    options: {
        zoomControl: true,
        mapTypeControl: false,
        scaleControl: false,
        streetViewControl: false,
        rotateControl: false,
        fullscreenControl: false
    },
    libraries: ['places']
};

const MobileMapOverlay = ({
    coworkingSpaces,
    startDate,
    endDate,
    coordinates,
    zoom,
    onLoad,
    onUnmount,
    setSelectedSpace,
    hoveredMarkerId,
    setHoveredMarkerId,
    isManualPan,
    listItemRefs,
    moveToSlide,
    moveMapToLocation,
    swiperRef,
    setIsMapVisible,
    dateClicked,
    createMarkerIcon,
    scrollToListItem
}) => (
    <Box
        sx={{
            position: 'fixed',
            top: 0,
            left: 0,
            right: 0,
            bottom: 0,
            backgroundColor: 'background.paper',
            zIndex: 2000, // Higher than everything
            display: 'flex',
            flexDirection: 'column'
        }}
    >
        {/* Close button */}
        <Button
            variant="contained"
            onClick={() => setIsMapVisible(false)}
            sx={{
                position: 'absolute',
                top: 16,
                right: 16,
                zIndex: 2100,
                borderRadius: '20px'
            }}
        >
            Close Map
        </Button>

        {/* Map takes all available space */}
        <Box sx={{ flex: 1, position: 'relative' }}>
            <GoogleMap
                mapContainerStyle={{
                    width: '100%',
                    height: '100%'
                }}
                center={coordinates}
                zoom={zoom}
                options={MAP_CONFIG.options}
                onLoad={onLoad}
                onUnmount={onUnmount}
            >
                {coworkingSpaces?.map(space => (
                    <Marker
                        key={space.slug}
                        position={{
                            lat: space.venue_location[1],
                            lng: space.venue_location[0]
                        }}
                        icon={createMarkerIcon(space, space.slug === hoveredMarkerId)}
                        onClick={() => {
                            scrollToListItem(space.slug);
                            moveToSlide(space.slug);
                        }}
                        onMouseOver={() => setHoveredMarkerId(space.slug)}
                        onMouseOut={() => setHoveredMarkerId(null)}
                    />
                ))}
            </GoogleMap>
        </Box>

        {/* Carousel fixed at bottom */}
        <Box
            sx={{
                height: '170px',
                borderTop: 1,
                borderColor: 'divider',
                backgroundColor: 'background.paper'
            }}
        >
            <MobileSpacesList
                spaces={coworkingSpaces}
                setSelectedSpace={setSelectedSpace}
                startDate={startDate}
                endDate={endDate}
                hoveredMarkerId={hoveredMarkerId}
                setHoveredMarkerId={setHoveredMarkerId}
                isManualPan={isManualPan}
                listItemRefs={listItemRefs}
                moveToSlide={moveToSlide}
                moveMapToLocation={moveMapToLocation}
                onDetailClick={dateClicked}
                swiperRef={swiperRef}
            />
        </Box>
    </Box>
);

export default MobileMapOverlay;